import { api } from 'xadmin';

const getUrl = (url) => {
  const host = api({ name: 'core' }).getHost()
  return (host + url || '').replace('//', '/')
}

export { getUrl }
